import { render, staticRenderFns } from "./HomeViewMessageCenter.vue?vue&type=template&id=bf69b3ae"
import script from "./HomeViewMessageCenter.vue?vue&type=script&lang=js"
export * from "./HomeViewMessageCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports